var BASE = '/api/recipes';
var headers = { 'Content-Type': 'application/json' };
var opts = { credentials: 'include', headers: headers };

async function handleResponse(res, fallbackMsg) {
  if (res.ok) return res.json();
  var body;
  try { body = await res.json(); } catch (e) { body = null; }
  var msg = body?.error || body?.message || fallbackMsg;
  if (res.status === 401) msg = 'Session expired — please log in again';
  throw new Error(msg);
}

export var fetchRecipes = async (params) => {
  var url = BASE;
  var qs = [];
  if (params?.category) qs.push('category=' + params.category);
  if (params?.search) qs.push('search=' + encodeURIComponent(params.search));
  if (params?.favorite) qs.push('favorite=true');
  if (qs.length) url += '?' + qs.join('&');
  var res = await fetch(url, { credentials: 'include' });
  return handleResponse(res, 'Failed to fetch recipes');
};

export var createRecipe = async (data) => {
  var res = await fetch(BASE, { ...opts, method: 'POST', body: JSON.stringify(data) });
  return handleResponse(res, 'Failed to create recipe');
};

export var updateRecipe = async (id, data) => {
  var res = await fetch(BASE + '/' + id, { ...opts, method: 'PUT', body: JSON.stringify(data) });
  return handleResponse(res, 'Failed to update recipe');
};

export var deleteRecipe = async (id) => {
  var res = await fetch(BASE + '/' + id, { ...opts, method: 'DELETE' });
  return handleResponse(res, 'Failed to delete recipe');
};
